<template>
    <section>
        <div class="page">
            <div>
                <h2>
                    Configuring video auto-download to phone memory
                </h2>
                <p>
                    By default, ToTok will automatically download videos only on WiFi to provide you with quick access
                    to your latest videos. Audio and video will automatically download on WiFi only.
                </p>
                <p>
                    You can manage your preferences by opening <strong>ToTok</strong> > <strong>Me</strong> > <strong>Chat
                    Settings</strong> > <strong>Auto-download Videos</strong>. Here you can choose when ToTok will
                    automatically download videos. Choose <strong>Never, WiFi Only, </strong>or
                    <strong>WiFi/4G/3G/2G</strong>.
                </p>
                <h3>
                    Never
                </h3>
                <p>
                    Videos will never automatically download. You will need to manually tap each video to download it.
                </p>
                <p>
                    Note: If you set your Auto-Download settings to Never, your videos won't automatically download.
                    However, once you tap on the play button, the video will start playing right away and continue the
                    download process in the background.
                </p>
                <h3>
                    WiFi Only
                </h3>
                <p>
                    Videos will automatically download when you are connected to a WiFi hotspot (e.g. your home
                    Internet).
                </p>
                <h3>
                    WiFi/4G/3G/2G
                </h3>
                <p>
                    Videos will automatically download whenever you have an Internet connection.
                </p>
                <p>
                    If you have a limited data plan, we suggest you restrict videos to auto-download when connected to
                    WiFi only.
                </p>


            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
